import { createContext } from 'react';
const MenuContext = /*#__PURE__*/createContext({
  prefixCls: '',
  firstLevel: true,
  inlineCollapsed: false
});
var MenuContext$1 = MenuContext;
export { MenuContext$1 as default };
//# sourceMappingURL=MenuContext.js.map
